import styled from 'styled-components';
import Tag from 'components/generic/tag';

const TagContainer = styled.div`
    position: absolute;
    top: ${({ theme }) => theme.Spacing8};
    left: ${({ theme }) => theme.Spacing8};
    right: ${({ theme }) => theme.Spacing8};
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.Spacing4};
`;

function TagList({ tags }: { tags?: string[] }) {
    if (!tags?.length) return null;
    return (
        <TagContainer>
            {tags.map((tag, index) => (
                <Tag key={index} text={tag} variant="default" />
            ))}
        </TagContainer>
    );
}

export default TagList;
